import { render, staticRenderFns } from "./mailConfiguration.vue?vue&type=template&id=4ee79141&scoped=true&"
import script from "./mailConfiguration.vue?vue&type=script&lang=js&"
export * from "./mailConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee79141",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ee79141')) {
      api.createRecord('4ee79141', component.options)
    } else {
      api.reload('4ee79141', component.options)
    }
    module.hot.accept("./mailConfiguration.vue?vue&type=template&id=4ee79141&scoped=true&", function () {
      api.rerender('4ee79141', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mail/mailConfiguration.vue"
export default component.exports